import { type FC, useState } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import LabeledInput from 'modules/core/components/LabeledInput'
import i18n from 'modules/core/lib/i18n'

import Item from './Item'

interface Props {
  onChange: (levels: string[]) => void
}

const LevelsInput: FC<Props> = ({ onChange }) => {
  const [levels, setLevels] = useState<string[]>([])

  const items = levels.map((_, i) => {
    const handleDelete = () => {
      const nextLevels = levels.filter((_, ii) => i !== ii)

      setLevels(nextLevels)
      onChange(nextLevels)
    }

    const handleChange = (change: string) => {
      const nextLevels = levels.slice()
      nextLevels[i] = change

      setLevels(nextLevels)
      onChange(nextLevels.filter((x) => x.trim() !== ''))
    }

    return <Item key={i} onChange={handleChange} onDelete={handleDelete} />
  })

  const handleAddLevel = () => {
    setLevels([...levels, ''])
  }

  return (
    <Box paddingBottom="s24">
      <LabeledInput label={i18n.t('job_catalog.levels')} isLegend>
        {items.length > 0 ? items : <Box paddingBottom="s16" gap="s8" />}
        <Button
          onClick={handleAddLevel}
          type="secondary"
          iconName="add"
          extra={{
            'data-intercom-target': 'job-catalog-new-job-levels-input-add-level-button',
          }}
        >
          {i18n.t('job_catalog.add_level')}
        </Button>
      </LabeledInput>
    </Box>
  )
}

export default observer(LevelsInput)
